import Vue from 'vue'
import Snackbar from "@/components/widget/Snackbar.vue";
import Box from "@/components/widget/Box.vue";
import DailyDatePicker from "@/components/widget/DailyDatePicker.vue";
import PeriodDatePicker from "@/components/widget/PeriodDatePicker.vue";
import MonthlyDatePicker from "@/components/widget/MonthlyDatePicker.vue";
import EosDialog from "@/components/widget/EosDialog.vue";
import EmptyList from "@/components/widget/EmptyList.vue";

Vue.component("Snackbar", Snackbar);
Vue.component("Box", Box);
Vue.component("DailyDatePicker", DailyDatePicker);
Vue.component("PeriodDatePicker", PeriodDatePicker);
Vue.component("MonthlyDatePicker", MonthlyDatePicker);
Vue.component("EosDialog", EosDialog);
Vue.component("EmptyList", EmptyList);